/** parseScheduleFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseScheduleFilters = (params /* URLSearchParams */) => ({
  // Filters
  name_cnts: params.get("name_cnts"),
  id: params.get("id"),
  from: params.get("from"),
  to: params.get("to"),
  astrosite_id: params.get("astrosite_id"),
  sort_order: params.get("sort_order") || "DESC",
  sort_by: params.get("sort_by") || "created",
})
